import { createReducer, on } from "@ngrx/store";
import { Bank, MerchantProduct, MerchantSettlementBankAccount, MerchantWallet, ProductCategory, ValidatedAccount } from "./products.interfaces";
import * as productActions from './products.actions';

export interface ProductsState {
    merchantProducts: MerchantProduct[] | null
    fetchMerchantProductsError: boolean
    loadingMerchantProducts: boolean

    banks: Bank[] | null
    banksError: boolean
    loadingBanks: boolean

    wallets: MerchantWallet[] | null
    walletsError: boolean
    loadingWallet: boolean

    settlementAccount: MerchantSettlementBankAccount[] | null
    settlementAccountError: boolean
    loadingSettlementAccount: boolean

    productCategories: ProductCategory[] | null
    productCategoriesError: boolean
    loadingProductCategories: boolean

    validatedAccount: ValidatedAccount | null
    validatingAccountError: boolean
    validatingAccount: boolean
}

export const initialState: ProductsState = {
    merchantProducts: null,
    fetchMerchantProductsError: null,
    loadingMerchantProducts: null,

    banks: null,
    banksError: null,
    loadingBanks: null,

    wallets:  null,
    walletsError: null,
    loadingWallet: null,

    settlementAccount: null,
    settlementAccountError: null,
    loadingSettlementAccount: null,

    productCategories: null,
    productCategoriesError: null,
    loadingProductCategories: null,

    validatedAccount: null,
    validatingAccountError: null,
    validatingAccount: null,
}

export const ProductsReducer = createReducer(
    initialState,

    on(productActions.fetchMerchantProducts, (state) => ({
        ...state, merchantProducts: null, fetchMerchantProductsError: null, loadingMerchantProducts: true
    })),

    on(productActions.fetchMerchantProductsSuccess, (state, {merchantProducts}) => ({
        ...state, merchantProducts: merchantProducts, fetchMerchantProductsError: false, loadingMerchantProducts: false
    })),

    on(productActions.fetchMerchantProductsFailed, (state) => ({
        ...state, merchantProducts: null, fetchMerchantProductsError: true, loadingMerchantProducts: false
    })),



    on(productActions.fetchProductCategories, (state) => ({
        ...state, productCategories: null, productCategoriesError: null, loadingProductCategories: true
    })),

    on(productActions.fetchProductCategoriesSuccess, (state, {productCategories}) => ({
        ...state, productCategories: productCategories, productCategoriesError: false, loadingProductCategories: false
    })),

    on(productActions.fetchProductCategoriesFailed, (state) => ({
        ...state, productCategories: null, productCategoriesError: true, loadingProductCategories: false
    })),



    on(productActions.fetchBanks, (state) => ({
        ...state, banks: null, banksError: null, loadingBanks: true
    })),

    on(productActions.fetchBanksSuccess, (state, {banks}) => ({
        ...state, banks: banks, banksError: false, loadingBanks: false
    })),

    on(productActions.fetchBanksFailed, (state) => ({
        ...state, banks: null, banksError: true, loadingBanks: false
    })),



    on(productActions.fetchWallets, (state) => ({
        ...state, wallets: null, walletsError: null, loadingWallet: true
    })),

    on(productActions.fetchWalletsSuccess, (state, {wallets}) => ({
        ...state, wallets: wallets, walletsError: false, loadingWallet: false
    })),

    on(productActions.fetchWalletsFailed, (state) => ({
        ...state, wallets: null, walletsError: true, loadingWallet: false
    })),



    on(productActions.fetchSettlementAccount, (state) => ({
        ...state, settlementAccount: null, settlementAccountError: null, loadingSettlementAccount: true
    })),

    on(productActions.fetchSettlementAccountSuccess, (state, {settlementAccounts}) => ({
        ...state, settlementAccount: settlementAccounts, settlementAccountError: false, loadingSettlementAccount: false
    })),

    on(productActions.fetchSettlementAccountFailed, (state) => ({
        ...state, settlementAccount: null, settlementAccountError: true, loadingSettlementAccount: false
    })),




    on(productActions.validateAccount, (state) => ({
        ...state, validatedAccount: null, validatingAccountError: null, validatingAccount: true
    })),

    on(productActions.validateAccountSuccess, (state, {accountDetails}) => ({
        ...state, validatedAccount: accountDetails, validatingAccountError: false, validatingAccount: false
    })),

    on(productActions.validateAccountFailed, (state) => ({
        ...state, validatedAccount: null, validatingAccountError: true, validatingAccount: false
    })),
)